// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file cos/nextwork.proto (package lvdr.v2.cos, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file cos/nextwork.proto.
 */
export const file_cos_nextwork: GenFile = /*@__PURE__*/
  fileDesc("ChJjb3MvbmV4dHdvcmsucHJvdG8SC2x2ZHIudjIuY29zIhQKEkdldE5leHRXb3JrUmVxdWVzdCLUAQoTR2V0TmV4dFdvcmtSZXNwb25zZRIqCgZncm91cHMYASADKAsyGi5sdmRyLnYyLmNvcy5OZXh0V29ya0dyb3VwEgwKBGNhbG0YAiABKAgSGwoTbmV4dF9wcmVzZW50YWJsZV9tcxgDIAEoAxIQCghkZWdyYWRlZBgEIAMoCRISCgpzY29wZWRfb3V0GAUgAygJEhIKCnNjb3BlX25hbWUYBiABKAkSFwoPZ2VuZXJhdGVkX2F0X21zGAcgASgDEhMKC2NhbG1fcmVhc29uGAggASgJIogBCg1OZXh0V29ya0dyb3VwEiwKBGtpbmQYASABKA4yHi5sdmRyLnYyLmNvcy5OZXh0V29ya0dyb3VwS2luZBIOCgZyZWFzb24YAiABKAkSDAoEbW9yZRgDIAEoBRIrCgdlbnRyaWVzGAQgAygLMhoubHZkci52Mi5jb3MuTmV4dFdvcmtFbnRyeSKYAgoNTmV4dFdvcmtFbnRyeRIKCgJpZBgBIAEoCRINCgViYXRjaBgCIAEoCBISCgpiYXRjaF9uYW1lGAMgASgJEg4KBnNvdXJjZRgEIAEoCRINCgV0aXRsZRgFIAEoCRIOCgZyZWFzb24YBiABKAkSEQoJYXR0ZW50aW9uGAcgASgJEhcKD2F0dGVudGlvbl91bnNldBgIIAEoCBIOCgZ1cmdlbnQYCSABKAgSEQoJY29udGludWVzGAogASgIEiwKB21lbWJlcnMYCyADKAsyGy5sdmRyLnYyLmNvcy5OZXh0V29ya01lbWJlchIsCgdhY3Rpb25zGAwgAygLMhsubHZkci52Mi5jb3MuTmV4dFdvcmtBY3Rpb24iTwoOTmV4dFdvcmtNZW1iZXISCwoDcmVmGAEgASgJEg0KBXRpdGxlGAIgASgJEg4KBnJlYXNvbhgDIAEoCRIRCglhdHRlbnRpb24YBCABKAkiPAoOTmV4dFdvcmtBY3Rpb24SCgoCaWQYASABKAkSDAoEbGluaxgCIAEoCRIQCgh0YXNrX2lkcxgDIAMoCSI0ChVSZXBvcnRBY3Rpdml0eVJlcXVlc3QSCwoDcmVmGAEgASgJEg4KBmNsb3NlZBgCIAEoCCIqChZSZXBvcnRBY3Rpdml0eVJlc3BvbnNlEhAKCHJlY29yZGVkGAEgASgIKpYBChFOZXh0V29ya0dyb3VwS2luZBIkCiBORVhUX1dPUktfR1JPVVBfS0lORF9VTlNQRUNJRklFRBAAEhwKGE5FWFRfV09SS19HUk9VUF9LSU5EX05PVxABEh0KGU5FWFRfV09SS19HUk9VUF9LSU5EX0RFRVAQAhIeChpORVhUX1dPUktfR1JPVVBfS0lORF9MSUdIVBADQiRaImdpdGh1Yi5jb20vZ3ZzNDIvbHZkci9wcm90by92Mi9jb3NiBnByb3RvMw");

/**
 * @generated from message lvdr.v2.cos.GetNextWorkRequest
 */
export type GetNextWorkRequest = Message<"lvdr.v2.cos.GetNextWorkRequest"> & {
};

/**
 * Describes the message lvdr.v2.cos.GetNextWorkRequest.
 * Use `create(GetNextWorkRequestSchema)` to create a new message.
 */
export const GetNextWorkRequestSchema: GenMessage<GetNextWorkRequest> = /*@__PURE__*/
  messageDesc(file_cos_nextwork, 0);

/**
 * @generated from message lvdr.v2.cos.GetNextWorkResponse
 */
export type GetNextWorkResponse = Message<"lvdr.v2.cos.GetNextWorkResponse"> & {
  /**
   * in display order
   *
   * @generated from field: repeated lvdr.v2.cos.NextWorkGroup groups = 1;
   */
  groups: NextWorkGroup[];

  /**
   * @generated from field: bool calm = 2;
   */
  calm: boolean;

  /**
   * 0 = none known
   *
   * @generated from field: int64 next_presentable_ms = 3;
   */
  nextPresentableMs: bigint;

  /**
   * source names, "batches", "rhythm", "current_activity"
   *
   * @generated from field: repeated string degraded = 4;
   */
  degraded: string[];

  /**
   * @generated from field: repeated string scoped_out = 5;
   */
  scopedOut: string[];

  /**
   * @generated from field: string scope_name = 6;
   */
  scopeName: string;

  /**
   * @generated from field: int64 generated_at_ms = 7;
   */
  generatedAtMs: bigint;

  /**
   * quiet_hours | outside_work_hours | outside_present_window; "" when not calm
   *
   * @generated from field: string calm_reason = 8;
   */
  calmReason: string;
};

/**
 * Describes the message lvdr.v2.cos.GetNextWorkResponse.
 * Use `create(GetNextWorkResponseSchema)` to create a new message.
 */
export const GetNextWorkResponseSchema: GenMessage<GetNextWorkResponse> = /*@__PURE__*/
  messageDesc(file_cos_nextwork, 1);

/**
 * @generated from message lvdr.v2.cos.NextWorkGroup
 */
export type NextWorkGroup = Message<"lvdr.v2.cos.NextWorkGroup"> & {
  /**
   * @generated from field: lvdr.v2.cos.NextWorkGroupKind kind = 1;
   */
  kind: NextWorkGroupKind;

  /**
   * @generated from field: string reason = 2;
   */
  reason: string;

  /**
   * @generated from field: int32 more = 3;
   */
  more: number;

  /**
   * @generated from field: repeated lvdr.v2.cos.NextWorkEntry entries = 4;
   */
  entries: NextWorkEntry[];
};

/**
 * Describes the message lvdr.v2.cos.NextWorkGroup.
 * Use `create(NextWorkGroupSchema)` to create a new message.
 */
export const NextWorkGroupSchema: GenMessage<NextWorkGroup> = /*@__PURE__*/
  messageDesc(file_cos_nextwork, 2);

/**
 * @generated from message lvdr.v2.cos.NextWorkEntry
 */
export type NextWorkEntry = Message<"lvdr.v2.cos.NextWorkEntry"> & {
  /**
   * "<source>:<id>" or the batch id
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: bool batch = 2;
   */
  batch: boolean;

  /**
   * @generated from field: string batch_name = 3;
   */
  batchName: string;

  /**
   * @generated from field: string source = 4;
   */
  source: string;

  /**
   * @generated from field: string title = 5;
   */
  title: string;

  /**
   * @generated from field: string reason = 6;
   */
  reason: string;

  /**
   * "" = not set
   *
   * @generated from field: string attention = 7;
   */
  attention: string;

  /**
   * @generated from field: bool attention_unset = 8;
   */
  attentionUnset: boolean;

  /**
   * @generated from field: bool urgent = 9;
   */
  urgent: boolean;

  /**
   * @generated from field: bool continues = 10;
   */
  continues: boolean;

  /**
   * @generated from field: repeated lvdr.v2.cos.NextWorkMember members = 11;
   */
  members: NextWorkMember[];

  /**
   * @generated from field: repeated lvdr.v2.cos.NextWorkAction actions = 12;
   */
  actions: NextWorkAction[];
};

/**
 * Describes the message lvdr.v2.cos.NextWorkEntry.
 * Use `create(NextWorkEntrySchema)` to create a new message.
 */
export const NextWorkEntrySchema: GenMessage<NextWorkEntry> = /*@__PURE__*/
  messageDesc(file_cos_nextwork, 3);

/**
 * @generated from message lvdr.v2.cos.NextWorkMember
 */
export type NextWorkMember = Message<"lvdr.v2.cos.NextWorkMember"> & {
  /**
   * @generated from field: string ref = 1;
   */
  ref: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;

  /**
   * @generated from field: string attention = 4;
   */
  attention: string;
};

/**
 * Describes the message lvdr.v2.cos.NextWorkMember.
 * Use `create(NextWorkMemberSchema)` to create a new message.
 */
export const NextWorkMemberSchema: GenMessage<NextWorkMember> = /*@__PURE__*/
  messageDesc(file_cos_nextwork, 4);

/**
 * @generated from message lvdr.v2.cos.NextWorkAction
 */
export type NextWorkAction = Message<"lvdr.v2.cos.NextWorkAction"> & {
  /**
   * open | done | snooze | snooze_batch
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * open only
   *
   * @generated from field: string link = 2;
   */
  link: string;

  /**
   * snooze_batch only
   *
   * @generated from field: repeated string task_ids = 3;
   */
  taskIds: string[];
};

/**
 * Describes the message lvdr.v2.cos.NextWorkAction.
 * Use `create(NextWorkActionSchema)` to create a new message.
 */
export const NextWorkActionSchema: GenMessage<NextWorkAction> = /*@__PURE__*/
  messageDesc(file_cos_nextwork, 5);

/**
 * @generated from message lvdr.v2.cos.ReportActivityRequest
 */
export type ReportActivityRequest = Message<"lvdr.v2.cos.ReportActivityRequest"> & {
  /**
   * @generated from field: string ref = 1;
   */
  ref: string;

  /**
   * @generated from field: bool closed = 2;
   */
  closed: boolean;
};

/**
 * Describes the message lvdr.v2.cos.ReportActivityRequest.
 * Use `create(ReportActivityRequestSchema)` to create a new message.
 */
export const ReportActivityRequestSchema: GenMessage<ReportActivityRequest> = /*@__PURE__*/
  messageDesc(file_cos_nextwork, 6);

/**
 * @generated from message lvdr.v2.cos.ReportActivityResponse
 */
export type ReportActivityResponse = Message<"lvdr.v2.cos.ReportActivityResponse"> & {
  /**
   * @generated from field: bool recorded = 1;
   */
  recorded: boolean;
};

/**
 * Describes the message lvdr.v2.cos.ReportActivityResponse.
 * Use `create(ReportActivityResponseSchema)` to create a new message.
 */
export const ReportActivityResponseSchema: GenMessage<ReportActivityResponse> = /*@__PURE__*/
  messageDesc(file_cos_nextwork, 7);

/**
 * @generated from enum lvdr.v2.cos.NextWorkGroupKind
 */
export enum NextWorkGroupKind {
  /**
   * @generated from enum value: NEXT_WORK_GROUP_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: NEXT_WORK_GROUP_KIND_NOW = 1;
   */
  NOW = 1,

  /**
   * @generated from enum value: NEXT_WORK_GROUP_KIND_DEEP = 2;
   */
  DEEP = 2,

  /**
   * @generated from enum value: NEXT_WORK_GROUP_KIND_LIGHT = 3;
   */
  LIGHT = 3,
}

/**
 * Describes the enum lvdr.v2.cos.NextWorkGroupKind.
 */
export const NextWorkGroupKindSchema: GenEnum<NextWorkGroupKind> = /*@__PURE__*/
  enumDesc(file_cos_nextwork, 0);

